'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { SectionWrapper } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import getInitiateWhatsappChatLinkForSARA from '@/services/landingPage.service';

const wordsArray = ['Exponential', 'Sustainable', 'Faster'];

const HeroSection = () => {
  const [wordIndex, setWordIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setWordIndex((prev) => (prev + 1) % wordsArray.length);
        setFade(true);
      }, 300);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SectionWrapper className='relative z-10 flex flex-col lg:flex-row items-center'>
      <div className='w-full lg:w-3/5 text-left'>
        <div
          className={`text-[1.75rem] xs:text-[2rem] sm:text-[2rem] md:text-[3rem] lg:text-[3.5rem] xl:text-[4rem] 2xl:text-[5rem] font-black leading-[1.25] text-stroke-normal xs:text-stroke-normal sm:text-stroke-normal md:text-stroke-bold lg:text-stroke-bold xl:text-stroke-bold tracking-normal xs:tracking-normal sm:tracking-normal md:tracking-wide`}
        >
          Unlock{' '}
          <span
            className={`bg-brand-gradient bg-clip-text text-transparent inline-block leading-[1.25] transition-opacity duration-300 ${
              fade ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {wordsArray[wordIndex]}
          </span>{' '}
          <br />
          Growth: Partner
          <br />
          with Hafla
        </div>
        <div className='mt-4 xs:mt-3 sm:mt-3 text-sm xs:text-sm sm:text-sm md:text-lg lg:text-lg'>
          Join the UAE&apos;s leading AI-powered event ecosystem. Gain more
          customers, streamline your operations, and effortlessly boost your
          earnings.
        </div>
        <Link
          className={`mt-6 xs:mt-4 sm:mt-4 inline-flex items-center justify-center gap-1 xs:gap-1.5 sm:gap-1 md:gap-2 rounded-lg px-3 xs:px-4 sm:px-3 md:px-6 py-2.5 xs:py-2.5 sm:py-3 md:py-4 text-sm xs:text-sm sm:text-sm md:text-base font-semibold shadow-lg bg-brand-gradient text-white hover:opacity-90 transition-opacity w-full xs:w-auto sm:w-auto`}
          href={getInitiateWhatsappChatLinkForSARA()}
          rel='noopener noreferrer nofollow'
          target='_blank'
        >
          <Image
            alt='WhatsApp'
            className='w-4 h-4 sm:w-5 sm:h-5'
            height={20}
            src={`${staticMediaStoreBaseURL}/icons/whatsapp-green.svg`}
            width={20}
          />
          Meet Sara - Your Onboarding Expert ✨
        </Link>
      </div>
      <div className='w-full lg:w-2/5 flex justify-center mt-8 lg:mt-0'>
        <div className='relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl'>
          <Image
            alt='Puzzle Illustration with floating points'
            className='w-full h-auto'
            height={500}
            priority
            src={`${staticMediaStoreBaseURL}/landing-page/hero-section/puzzle-illustration-with-floating-points-v1.png`}
            unoptimized
            width={600}
          />
        </div>
      </div>
    </SectionWrapper>
  );
};

export default HeroSection;
